import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BasicModal } from '../common/modals/BasicModal';
import BrowserUtils from '../../utils/BrowserUtils';
import InternetBankingActions from '../../actions/InternetBankingActions';
import HelpActionCreator from '../../actions/HelpActionCreator';
import { isBOrVMRetail } from '../../utils/BrandUtils';
import FaqAnyQuestionsLink from '../common/FaqAnyQuestionLinks';

/**
 * @todo
 * The quality of this component could be improved in future improvement work.
 */
class DigitalStatementsHelpModal extends Component {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
    this.faqAnchorClick = this.faqAnchorClick.bind(this);
  }

  closeModal() {
    this.props.helpModal(false);
  }

  faqAnchorClick() {
    HelpActionCreator.backSetUrl(
      'WEB-DIGITAL-STATEMENTS',
      this.props.content.prefrenceUrl
    );
    InternetBankingActions.navigateToWebTask('WEB-OPEN-FAQ');
  }

  render() {
    return !BrowserUtils.isMobileView() ? (
      <div>
        <BasicModal>
          <div className="modalb msg-popup digi-help-modal">
            <div className="modalb-header">
              <h4>{this.props.content.digitalModalHeader}</h4>
            </div>
            <div className="modalb-container">
              <h5>{this.props.content.digitalModalHeader1}</h5>
              <p>{this.props.content.digitalModalHeaderContent1}</p>
              <p>{this.props.content.digitalModalHeaderContent2}</p>
              <h5>{this.props.content.digitalModalHeader2}</h5>
              <p>{this.props.content.digitalModalHeaderContent3}</p>
              <p>
                {this.props.content.statementPreferenceModalContent12}
                <FaqAnyQuestionsLink
                  data={this.props.data}
                  content={this.props.content}
                  onClick={this.faqAnchorClick}
                />
              </p>
              {!isBOrVMRetail() && (
                <h5>{this.props.content.digitalModalHeader3}</h5>
              )}
              <p>{this.props.content.digitalModalHeaderContent4}</p>
            </div>
            <div className="modalb-footer">
              <button
                className="c-btn c-btn--default"
                onClick={this.closeModal}
              >
                {this.props.content.digitalModalButton}
              </button>
            </div>
          </div>
        </BasicModal>
      </div>
    ) : (
      <div>
        <div className="main-container financial-stories2 account-1">
          <div className="statement-info-modal">
            <div className="info-header">
              <h5>{this.props.content.digitalModalHeader}</h5>
            </div>
            <div className="info-container">
              <h5>{this.props.content.digitalModalHeader1}</h5>
              <p>{this.props.content.digitalModalHeaderContent1}</p>
              <p>{this.props.content.digitalModalHeaderContent2}</p>
              <h5>{this.props.content.digitalModalHeader2}</h5>
              <p>{this.props.content.digitalModalHeaderContent3}</p>
              <p>
                {this.props.content.statementPreferenceModalContent12}
                <FaqAnyQuestionsLink
                  data={this.props.data}
                  content={this.props.content}
                  onClick={this.faqAnchorClick}
                />
              </p>
              {!isBOrVMRetail() && (
                <h5>{this.props.content.digitalModalHeader3}</h5>
              )}
              <p>{this.props.content.digitalModalHeaderContent4}</p>
            </div>
            <div className="info-footer">
              <button
                className="c-btn c-btn--default"
                onClick={this.closeModal}
              >
                {this.props.content.digitalModalButton}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DigitalStatementsHelpModal.propTypes = {
  content: PropTypes.object,
  helpModal: PropTypes.func,
};

export { DigitalStatementsHelpModal };
